export default __webpack_public_path__ + "static/media/Search-icon-black.b184548d.svg";